import React, { Component } from "react";
import { Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { v4 as uuid } from 'uuid';
import DatePicker from 'react-datepicker';

const required = (val) => val && val.length;
const maxLength = (len) => (val) => !(val) || (val.length <= len);
const minLength = (len) => (val) => (val) && (val.length >= len);
const isNumber = (val) => !isNaN(Number(val));
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);


class AddDailyLogForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            chkDontClose: false,
            arrSubjects: [],
            arrSubjectsForDate: [],
            arrFilteredSubjects: [],
            subject: "",
            savedMessage: "",
            selectedDate: new Date(),
            startDate: new Date()
        }
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSubjectSelect = this.handleSubjectSelect.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.fetchSubjectsForDate = this.fetchSubjectsForDate.bind(this);
        //this.handleSubmit = this.handleSubmit.bind(this);

    }

    fetchSubjectsForDate(selectedDate) {
        // Implement logic to fetch subjects for the selected date from your database or API
        // Set the fetched subjects in the state arrSubjects
        // Loop through the items array and extract subjects
       // console.log("@@@@fetchSubjectsForDate selectedDate :" + selectedDate);
        const tmpSubjects = [];
        this.props.timetables.timetables.forEach((item) => {
            const sub = item.subject;
           // console.log("@@@@fetchSubjectsForDate sub :" + sub);
            item.schedule.forEach((sch) => {
                sch.schedule.forEach((day) => {
                    const startTimeDB = new Date(day.startTime);
                    const dateTimeState = new Date(selectedDate);

                    const timeDifference = dateTimeState > startTimeDB ? (dateTimeState - startTimeDB) : 'NA'; // Difference in milliseconds

                    if (timeDifference != 'NA') {
                        const daysDifference = Math.floor(timeDifference / (24 * 60 * 60 * 1000)); // Convert to days

                        // console.log("----fetchSubjectsForDate startTimeDB sub------------:" + sub);

                        // console.log("----fetchSubjectsForDate dateTimeState ------------:" + dateTimeState);

                        // console.log("----fetchSubjectsForDate startTimeDB :" + startTimeDB);

                        // console.log("----fetchSubjectsForDate daysDifference :" + daysDifference);

                        const startTimeDbDatePart = startTimeDB.toLocaleDateString(); // Use the user's browser settings
                        const datePartState = dateTimeState.toLocaleDateString(); // Use the user's browser settings

                        // console.log("----fetchSubjectsForDate divide by freq :" + daysDifference % (day.repetitionFrequency * 7));

                        // console.log("----fetchSubjectsForDate startTimeDbDatePart :" + startTimeDbDatePart);
                        // console.log("----fetchSubjectsForDate datePartState :" + datePartState);


                        if ((daysDifference % (day.repetitionFrequency * 7) == 0) || (startTimeDbDatePart == datePartState)) {
                            // Add the subject to the tmpSubjects array
                            // console.log("----fetchSubjectsForDate added subject to the array :" + sub);
                            tmpSubjects.push(sub);
                        }
                    }
                })

            })

        });

        // console.log("tmpSubjects :" + JSON.stringify(tmpSubjects));

        // Update the state with the subjects
        this.setState({ arrSubjectsForDate: tmpSubjects });

    }

    handleDateChange(selectedDate) {
        // console.log ("selectedDate :" + selectedDate);

        const updateDate = new Date(selectedDate).setHours(23, 59, 59, 999);// we have to use sethours with these values so that the calculation is accurate

        this.setState({
            startDate: updateDate // Update the selected date in the state
        });

        this.fetchSubjectsForDate(updateDate);
    }

    handleSubjectSelect(subject) {
        this.setState(
            {
                subject: subject
            }
        )

    }


    handleFilterChange(event) {

        const filteredSubjects = this.state.arrSubjects.filter(subject =>
            subject.toLowerCase().includes(event.target.value.toLowerCase())
        )

        this.setState({
            arrFilteredSubjects: filteredSubjects,
            subject: event.target.value
        })
    }



    handleChange(event) {
        switch (event.target.id) {
            case "chkDontToggle":
                if (event.target.checked) {
                    this.setState({
                        chkDontClose: true
                    })
                } else {
                    this.setState({
                        chkDontClose: false
                    })
                }
        }

    }


    toggleNav() {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });

        /*
        create an object called subject with unique subject values derived from the dailylogs props.
        it iterates through dailylog, extracts subjects and creates an object with subject as the key and frequency of the 
        occurence of subject as the value
        */
        const subjects = this.props.timetables.timetables.reduce((acc, day) => {
            const subValue = day.subject;
            if (subValue in acc) {
                acc[subValue]++;
            } else {
                acc[subValue] = 1;
            }
            return acc;
        }, {});

        //alert(JSON.stringify(subjects));

        // Get a sorted list of unique due dates
        const uniquesubjects = Object.keys(subjects).sort((a, b) => a.localeCompare(b));

        //alert (JSON.stringify(this.props.timetables));

        this.fetchSubjectsForDate(this.state.selectedDate);

        this.setState({
            arrSubjects: uniquesubjects,
            subject: "",
            savedMessage: ""
        })
        //alert(JSON.stringify(uniquesubjects));


    }

    handleLogin(event) {

        this.toggleModal();
        // alert("Username: " + this.username.value + " Password:" + this.password.value);
        alert("Username: " + this.username.value + " Password:" + this.password.value
            + " Remember: " + this.remember.checked);
        event.preventDefault();
    }

    handleSubmit(values) {
        //alert(this.props.dailylogs.length);
        //alert(values.subject);
        //alert(values.topic);
        //alert(values.subtopic);
        //alert(values.comment);

        if (!this.state.chkDontClose) {
            this.toggleModal();
        }

        const unique_id = uuid();
        this.props.postComment(unique_id, this.state.startDate, this.state.subject, values.topic, values.subtopic, values.comment);

        this.setState({
            savedMessage: "Details Saved"
        })
        //alert("details saved");        
        //console.log("current state is :" + JSON.stringify(values));
        //alert("current state is :" + JSON.stringify(values));
        // alert(this.props.dishId);
        //alert(values.rating);
        //alert(values.author);
        //alert(values.comment);

    }


    componentDidMount() {


    }

    render() {

        // Create an object to store the counts of tasks for each due date
        //alert(JSON.stringify(this.props.dailylogs));


        return (
            <div>
                <Button outline onClick={this.toggleModal}>
                    <span className="fa fa-pencil fa-lg"></span> Add log
                </Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal} closeButton>Add Log</ModalHeader>
                    <ModalBody>
                        <Label md={12}>{this.state.savedMessage}</Label>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                            <Row className='form-group'>
                                <Label htmlFor="logdate" md={12}>Log Date:</Label>
                                <Col md={12}>
                                    <DatePicker
                                        selected={this.state.startDate}
                                        defaultValue={this.state.startDate}
                                        onChange={this.handleDateChange}
                                        name="logdate"
                                        dateFormat="dd/MM/yyyy"
                                        id="startDate"
                                    />

                                </Col>
                            </Row>

                            <Row className='form-group'>

                                <div className="subject-list">
                                    {this.state.arrSubjectsForDate.map(subject => (
                                        <div key={subject} onClick={() => this.handleSubjectSelect(subject)}>
                                            {subject}
                                        </div>
                                    ))}
                                </div>

                            </Row>




                            <Row className='form-group'>
                                <Label htmlFor="subject" md={12}>Subject</Label>
                                <Col md={12}>
                                    <Control.text model=".subject" id="subject" name="subject"
                                        placeholder="Subject"
                                        className="form-control"
                                        onChange={this.handleFilterChange}
                                        value={this.state.subject}
                                    />

                                    {this.state.arrFilteredSubjects.length > 0 && (
                                        <ul>
                                            {this.state.arrFilteredSubjects.map(subject => (
                                                <li key={subject} onClick={() => this.handleSubjectSelect(subject)}>{subject}</li>
                                            ))}
                                        </ul>
                                    )}
                                    {this.state.arrFilteredSubjects.length > 0 && this.state.arrFilteredSubjects.length === 0 && <p>No results found</p>}

                                </Col>
                            </Row>

                            <Row className='form-group'>
                                <Label htmlFor="topic" md={12}>Topic</Label>
                                <Col md={12}>
                                    <Control.text model=".topic" id="topic" name="topic"
                                        placeholder="Topic"
                                        className="form-control"
                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(50) }}
                                    />
                                    <Errors className="text-danger"
                                        model=".topic"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be greater than 2 characters',
                                            maxLength: 'Must be 50 characters or less'
                                        }}
                                    />

                                </Col>
                            </Row>

                            <Row className='form-group'>
                                <Label htmlFor="subtopic" md={12}>Sub Topic</Label>
                                <Col md={12}>
                                    <Control.text model=".subtopic" id="subtopic" name="subtopic"
                                        placeholder="Topic"
                                        className="form-control"
                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(75) }}
                                    />
                                    <Errors className="text-danger"
                                        model=".subtopic"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be greater than 2 characters',
                                            maxLength: 'Must be 75 characters or less'
                                        }}
                                    />

                                </Col>
                            </Row>

                            <Row className='form-group'>
                                <Label htmlFor="comment" md={12}>Comment</Label>
                                <Col md={12}>
                                    <Control.textarea model=".comment" id="comment" name="comment"
                                        rows="6"
                                        className="form-control" />
                                </Col>
                            </Row>
                            <Row className='form-group'>
                                <Col md={6}>
                                    <Button type="submit" color="primary">Submit</Button>
                                </Col>
                                <Col md={6}>
                                    <FormGroup check>
                                        <Input
                                            id="chkDontToggle"
                                            type="checkbox"
                                            checked={this.state.chkDontClose}
                                            onChange={(event) => this.handleChange(event)}
                                        />
                                        {' '}
                                        <Label check>
                                            Create more dailylog
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </LocalForm>
                    </ModalBody>
                </Modal>
            </div>
        );
    }

}
export default AddDailyLogForm;